import React__default from 'react';
import JSONTree from 'react-native-json-tree';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppText } from './index-6b88191c.esm.js';

const AppJSONViewer = _ref => {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8, _currentTheme$theme9, _currentTheme$theme10, _currentTheme$theme11, _currentTheme$theme12, _currentTheme$theme13, _currentTheme$theme14, _currentTheme$theme15;
  let {
    json,
    fontColor,
    minLevelExpanded = 3
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const theme = {
    scheme: "monokai",
    author: "wimer hazenberg (http://www.monokai.nl)",
    base00: "transparent",
    base01: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color,
    base02: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.font_color,
    base03: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.darkGrey,
    base04: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.font_color,
    base05: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.font_color,
    base06: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.font_color,
    base07: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.font_color,
    base08: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.font_color,
    base09: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.font_color,
    base0A: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.font_color,
    base0B: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.darkGrey,
    base0C: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme12 = currentTheme.theme) === null || _currentTheme$theme12 === void 0 ? void 0 : _currentTheme$theme12.font_color,
    base0D: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme13 = currentTheme.theme) === null || _currentTheme$theme13 === void 0 ? void 0 : _currentTheme$theme13.darkGrey,
    base0E: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme14 = currentTheme.theme) === null || _currentTheme$theme14 === void 0 ? void 0 : _currentTheme$theme14.font_color,
    base0F: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme15 = currentTheme.theme) === null || _currentTheme$theme15 === void 0 ? void 0 : _currentTheme$theme15.font_color
  };
  return /*#__PURE__*/React__default.createElement(JSONTree, {
    accessibilityLabel: "json-tree"
    // getItemString={(type, data, itemType, itemString) => (
    //   <View
    //     style={{
    //       flexDirection: "row",
    //       alignItems: "center",
    //     }}
    //   >
    //     <AppText
    //       style={{
    //         marginRight: 3,
    //       }}
    //     >
    //       {itemType}
    //     </AppText>
    //     <AppText>{itemString}</AppText>
    //   </View>
    // )}
    ,
    shouldExpandNode: (_keyName, _data, level) => {
      return level < minLevelExpanded;
    },
    hideRoot: true,
    data: json,
    labelRenderer: _ref2 => {
      var _currentTheme$theme16;
      let [raw] = _ref2;
      return /*#__PURE__*/React__default.createElement(AppText, {
        preventTranslation: true,
        style: {
          fontWeight: "bold",
          fontSize: 13,
          color: fontColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme16 = currentTheme.theme) === null || _currentTheme$theme16 === void 0 ? void 0 : _currentTheme$theme16.font_color)
        }
      }, "".concat(raw, " :"));
    },
    valueRenderer: raw => {
      var _currentTheme$theme17;
      return /*#__PURE__*/React__default.createElement(AppText, {
        preventTranslation: true,
        style: {
          // fontStyle: "italic",
          fontSize: 13,
          color: fontColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme17 = currentTheme.theme) === null || _currentTheme$theme17 === void 0 ? void 0 : _currentTheme$theme17.font_color)
        }
      }, raw);
    },
    theme: theme,
    invertTheme: false
  });
};
AppJSONViewer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppJSONViewer",
  "props": {
    "minLevelExpanded": {
      "defaultValue": {
        "value": "3",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "json": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": "JSON to display"
    },
    "fontColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    }
  }
};

export { AppJSONViewer as A };
